import Vue from "vue";
import Router from "vue-router";
import provider from "../libs/provider";
import googleRoutes from "./google";
import microsoftRoutes from "./microsoft";
import appleRoutes from "./apple";
import Error404 from "@/components/errors/404";
import ErrorSchoolConnection from "@/components/errors/SchoolConnection.vue";
import ErrorOrangisationNotActive from "@/components/errors/OrganisationNotActive.vue"
import DirectoryLayout from "@/components/directory/Layout";
import DirectoryIndex from "@/components/directory/Index";
import DirectorySync from "@/components/directory/Sync";
import DirectorySyncRun from "@/components/directory/SyncRun";
import Settings from "@/components/Settings";
import ConnectReconnect from "@/components/ConnectReconnect";
import ConnectReturn from "@/components/ConnectReturn";
import AuthLogin from "@/components/auth/Login";
import AuthLoginReturn from "@/components/auth/LoginReturn";
import JWTLoginReturn from "@/components/auth/JWTLoginReturn";
import WizardStepOne from "@/components/wizard/StepOne";
import WizardStepTwo from "@/components/wizard/StepTwo";
import WizardStepThree from "@/components/wizard/StepThree";
import WizardStepFour from "@/components/wizard/StepFour";
import RegionDetect from "@/components/RegionDetect";
import Auth from "@/components/auth/Auth";

Vue.use(Router);

const providerRoutes = {
    gapps: googleRoutes,
    msft: microsoftRoutes,
    apl: appleRoutes,
}

const baseRoutes = [
    {
        name: "dashboard",
        path: "/",
        component: DirectoryIndex,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
        path: "/directory",
        component: DirectoryLayout,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        },
        children: [
            {
                name: "directory",
                path: "",
                component: DirectoryIndex,
                meta: {
                    requiresAuth: true,
                    requiresShard: true,
                    completedWizard: true
                }
            },
            {
                name: "directory.sync",
                path: "/directory/sync",
                components: {
                    default: DirectorySync
                },
                meta: {
                    requiresAuth: true,
                    requiresShard: true,
                    completedWizard: true
                }
            },
            {
                name: "directory.sync.run",
                path: "/directory/sync/run/:uuid",
                components: {
                    default: DirectorySyncRun
                },
                meta: {
                    requiresAuth: true,
                    requiresShard: true,
                    completedWizard: true
                }
            }
        ]
    },
    {
        name: "region",
        path: "/region",
        component: RegionDetect,
        meta: {
            requiresAuth: true,
            requiresShard: false,
            layout: "auth"
        }
    },
    {
        name: "wizard",
        path: "/wizard",
        component: WizardStepOne,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false
        }
    },
    {
        name: "wizard.settings",
        path: "/wizard/settings",
        component: WizardStepTwo,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false
        }
    },
    {
        name: "wizard.match",
        path: "/wizard/match",
        component: WizardStepThree,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false
        }
    },
    {
        name: "wizard.classes",
        path: "/wizard/classes",
        component: WizardStepFour,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false
        }
    },
    {
        name: "settings",
        path: "/settings",
        component: Settings,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
        name: "connect.reconnect",
        path: "/reconnect",
        component: ConnectReconnect,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
        name: "connect.return",
        path: "/connect/return",
        component: ConnectReturn,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
        name: "login",
        path: "/login",
        component: AuthLogin,
        meta: {
            requiresAuth: false,
            requiresShard: false,
            layout: "auth"
        }
    },
    {
        name: "login.return",
        path: "/login/return",
        component: AuthLoginReturn,
        meta: {
            requiresAuth: false,
            requiresShard: false,
            layout: "auth"
        }
    },
    {
        name: "jwt.login",
        path: "/jwt/login",
        component: JWTLoginReturn,
        meta: {
            requiresAuth: false,
            requiresShard: false,
            layout: "auth"
        }
    },
    {
        name: "auth",
        path: "/auth",
        component: Auth,
        meta: {
            requiresAuth: false,
            requiresShard: false,
            layout: "auth"
        }
    },
    {
        name: "errors.404",
        path: "*",
        component: Error404,
        meta: {
            layout: "auth"
        }
    },
    {
        name: "errors.connection",
        path: "/errors/connection",
        component: ErrorSchoolConnection,
        meta: {
            layout: "auth"
        }
    },
    {
        name: "errors.organisationNotActive",
        path: "/errors/organisationNotActive",
        component: ErrorOrangisationNotActive,
        meta: {
            layout: "auth"
        }
    },
];

const routes = baseRoutes.concat(providerRoutes[provider.get().providerCode]);

export default new Router({
	mode: "history",
	routes: routes
});
